// JavaScript to be fired on Hotel Payments Processing

// Country list
import countries from './paymentCountries.json';
import bg from '../../images/payment-bg.svg'

export default {
  init() {
    $(function () {
      $.each(countries, function (index, value) {
        $('.payment-process .dropdown-menu').append('<a href="#" class="dropdown-item ' + value.id + '" value="' + value.value + '"><small>' + value.name + '</small></a>');
      });

      $('.lh-pay').css({'background-image': 'url(' + bg + ')', 'background-size': 'cover', 'background-repeat': 'no-repeat', 'background-position': 'center 65%'}).hide();
      $('.stripe').css({'background-image': 'url(' + bg + ')', 'background-size': 'cover', 'background-repeat': 'no-repeat', 'background-position': 'center 80%'}).hide();


      $('.payment-process .dropdown-menu a').click(function(e){
        e.preventDefault();
        $('.payment-process .dropdown-toggle .btn-text').text($(this).text()).attr('value', $(this).attr('value'));

        var val = $(this).attr('value');
        if (val === 'opt1') {
          if ($('.stripe').is(':visible')) {
            $('.stripe').slideDown('slow', function () {
              $(this).hide();
            });
          }

          $('.lh-pay').slideDown('slow', function() {
            $(this).fadeIn('slow').show();
          });

        } else {
          if ($('.lh-pay').is(':visible')) {
            $('.lh-pay').slideDown('slow', function() {
              $(this).hide();
            });
          }

          $('.stripe').slideDown('slow', function() {
            $(this).css({'background-image': 'url(' + bg + ')', 'background-size': 'cover', 'background-repeat': 'no-repeat', 'background-position': 'center 80%'}).fadeIn('slow').show();
          });
        }
      });
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/countryPicker.js